import React from 'react';
import { heroStats, topReviews } from '../data/content';
export function ReviewsBar() {
  return <section aria-label="Coach reviews and statistics" className="w-full bg-white px-5 py-10 sm:px-8" data-id="element-238" data-mp="2oa68swy3ed89">
      <div className="mx-auto w-full max-w-6xl" data-id="element-239" data-mp="31zq8tv0agwdv">
        <div className="grid grid-cols-2 gap-6 rounded-2xl border border-neutral-200 bg-neutral-50 px-6 py-6 sm:grid-cols-4" data-id="element-240" data-mp="2x1ygx0zn9a9o">
          {heroStats.map(stat => <div key={stat.label} className="text-center" data-id="element-241" data-mp="29cvz9t50fhf6">
              <p className="text-2xl font-extrabold text-[#6d28d9] sm:text-3xl" data-id="element-242" data-mp="25bk9nnm4yw6z">
                {stat.value}
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-neutral-600" data-id="element-243" data-mp="2jbczzhtr3aef">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-244" data-mp="3uofco1sqbftb">
          {topReviews.map(review => <figure key={review.name} className="rounded-2xl border border-neutral-200 bg-white p-6" data-id="element-245" data-mp="3ppud84lax05x">
              <p className="text-lg" aria-label="5 out of 5 stars" data-id="element-246" data-mp="1c7d1hcdeodyi">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-3 text-[15px] font-medium italic leading-relaxed text-neutral-800" data-id="element-247" data-mp="1m36h54mf8nki">
                {review.quote}
              </blockquote>
              <figcaption className="mt-5" data-id="element-248" data-mp="1r1hsxkwa185d">
                <span className="block text-sm font-bold text-neutral-900" data-id="element-249" data-mp="tf0z4pmr5cod">
                  {review.name}
                </span>
                <span className="block text-xs text-neutral-500" data-id="element-250" data-mp="yedk14u2c9ob">{review.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}